// extracted by mini-css-extract-plugin
module.exports = {"EditoDoubleImage":"styles_EditoDoubleImage__3O4fb","content":"styles_content__YfKlo","box":"styles_box__2i5AM","isFirstBox":"styles_isFirstBox__nNmwa"};